import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f438983c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share" }
const _hoisted_2 = { class: "share__link" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "share__info" }
const _hoisted_7 = { class: "share__actions" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "share__details embed"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Code kopieren ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "share__details qrcode"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueQr3 = _resolveComponent("VueQr3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "text",
        value: _ctx.url,
        class: "share__url",
        ref: "input",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.copyUrl()), ["prevent"]))
      }, null, 8, _hoisted_3),
      _createElementVNode("button", {
        class: "share__copy",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.copyUrl()), ["prevent"]))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "share__action",
          href: _ctx.downloadUrl,
          download: ""
        }, " Herunterladen ", 8, _hoisted_8),
        _createElementVNode("a", {
          class: "share__action",
          href: "",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.actionDetails === 'embed' ? _ctx.actionDetails = 'none' : _ctx.actionDetails = 'embed'), ["prevent"]))
        }, " Einbetten "),
        _createElementVNode("a", {
          class: "share__action",
          href: "",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.actionDetails === 'qrcode' ? _ctx.actionDetails = 'none' : _ctx.actionDetails = 'qrcode'), ["prevent"]))
        }, " QR-Code ")
      ]),
      (_ctx.actionDetails === 'embed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("textarea", {
              class: "embed__code",
              value: _ctx.embedCode,
              ref: "embed",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.copyEmbedCode()), ["prevent"]))
            }, null, 8, _hoisted_10),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.copyEmbedCode()), ["prevent"])),
              class: "embed__btn"
            }, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (_ctx.actionDetails === 'qrcode')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_VueQr3, {
              data: _ctx.url,
              width: "400",
              height: "400",
              "dots-options": {type: 'square'},
              "corners-square-options": {type: ''},
              download: true,
              "download-button": "qrcode__btn",
              ButtonName: "QR-Code herunterladen",
              "download-options": {name: 'RecArena_' + _ctx.id, extension: 'png'}
            }, null, 8, ["data", "download-options"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}